import { useEffect, useMemo, useState } from "react";
import SyncStatus from "src/components/SyncStatus";
import { Utility } from "src/utils/Utility";
import AsyncSelect from "react-select/async";
import {
  getDeskeraProductBreifSearch,
  getDeskeraProductBrif,
  migrateBrightPearlMatchingProducts,
  saveBrightPearlMatchingProducts,
} from "src/api";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import customSelectTheme from "src/utils/selectTheme";
import { DKButton } from "deskera-ui-library";
import SearchLogo from "src/assets/Search";
import { useAsyncDebounce } from "react-table";
import ServerPaginationTable from "src/components/ServerPaginationTable";
import CloseIcon from "src/assets/Close";
import { addToast } from "src/redux/actions/toasts";
const PRODUCT_SYNC_STATUS_FILTER = [
  {
    name: "All",
    value: null,
  },
  {
    name: "Synced & Mapped",
    value: "SUCCESSFUL",
  },
  {
    name: "Synced & Pending to Map",
    value: "PENDING",
  },
  {
    name: "Failed to Map",
    value: "FAILED",
  },
];

const brightPearlStatusOption = [
  {
    label: "Product Name",
  },
  {
    value: "SKU",
    label: "SKU",
  },
];
function MapBrightPearlProducts(props) {
  const [productData, setProductData] = useState([]);
  const [data, setData] = useState([]);
  const [deskeraMappingField, setDeskeraMappingField] = useState("PRODUCT_NAME");
  const [brightPearlMappingField, setBrightPearlMappingField] = useState("PRODUCT_NAME");
  const [brightPearlStore, setBrightPearlStore] = useState(null);
  const accounts = useSelector((state) => state.brightpearl.accounts);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);
  const [sortBy, setSortBy] = useState();
  const [input, setInput] = useState("");
  const dispatch = useDispatch();
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [productSyncStatusFilter, setProductSyncStatusFilter] = useState(
    PRODUCT_SYNC_STATUS_FILTER[0]
  );
  const [error, setError] = useState("");
  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      minWidth: "13rem",
    }),
  };

  const [deskeraStatusOptions, setDeskeraStatusOptions] = useState([
    {
      value: "PRODUCT_NAME",
      label: "Product Name",
      isCustomField: false,
    },
    {
      value: "DOCUMENT_SEQ_CODE",
      label: "Product Seq Code",
      isCustomField: false,
    },
    {
      value: "BARCODE",
      label: "Barcode",
      isCustomField: false,
    },
  ]);

  const columns = useMemo(
    () => [
      {
        Header: "Product ID",
        accessor: "cartProductId",
      },
      {
        Header: "Name",
        accessor: "productName",
        Cell: ({ cell: { row } }) => (
          <span>
            {row.original.productName}{" "}
            {row.original.productVariantName &&
              row.original.productVariantName !== "Default Title" &&
              "(" + row.original.productVariantName + ")"}
          </span>
        ),
      },
      {
        Header: "SKU",
        accessor: "sku",
      },
      {
        Header: "Mapped Deskera Product",
        accessor: "deskeraDocumentCode",
        width: "350px",
        Cell: ({ cell: { row } }) => {
          return (
            <SelectProduct
              row={row}
              loadDeskeraOptions={loadDeskeraOptions}
              deskeraHandleChange={deskeraHandleChange}
              productData={productData}
              deskeraMappingField={deskeraMappingField}
              setProductData={setProductData}
            />
          );
        },
      },
      {
        Header: "Sync Status",
        accessor: "syncStatus",
        Cell: ({ cell: { row } }) => {
          return (
            <SyncStatus
              status={row.original.syncStatus}
              reason={row.original.reason}
              id={row.original.cartProductId}
            />
          );
        },
        disableGlobalFilter: true,
      },
    ],
    [data]
  );

  useEffect(() => {
    getBooksProducts();
  }, []);

  useEffect(() => {
    if (!isMapProductsDisabled()) {
      refreshData({ pageSize, pageIndex, sortBy });
    }
  }, [input, productSyncStatusFilter]);

  async function getBooksProducts() {
    try {
      const products = await getDeskeraProductBrif();
      setProductData(products);
    } catch {
      setError("Failed to load Deskera Books Products");
    }
  }

  const deskeraHandleChange = (e, index) => {
    let newData = Utility.deepClone(data);
    if (Utility.isNotEmpty(newData)) {
      newData[index] = {
        ...newData[index],
        deskeraDocumentCode: e.documentSequenceCode,
        deskeraId: e.pid,
        deskeraProductName: e.name,
        cartAccountId: brightPearlStore?.id || accounts?.data?.id,
      };
      setData(newData);
    }
  };

  const loadDeskeraOptions = async (inputValue) => {
    const config = {
      search: inputValue,
      limit: 25,
    };
    const response = await getDeskeraProductBreifSearch(config);
    if (inputValue === undefined || inputValue == "") {
      return response;
    }
    return response;
  };

  const isMapProductsDisabled = () => {
    if (
      (accounts.data.length > 1 ? !brightPearlStore?.id : accounts?.data?.id) ||
      !brightPearlMappingField ||
      !deskeraMappingField
    ) {
      return true;
    }

    return false;
  };

  const refreshData = async ({ pageSize, pageIndex, sortBy }) => {
    if (!loading) {
      setLoading(true);
      let payload = {
        deskeraMappingField: deskeraMappingField,
        brightpearlMappingField: brightPearlMappingField,
        showSucceedProducts: true,
        limit: pageSize,
        page: pageIndex,
        sortDir: "ASC",
        search: input,
        syncStatus: productSyncStatusFilter.value,
      };
      setPageSize(pageSize);
      setPageIndex(pageIndex);
      setSortBy(sortBy);

      await migrateBrightPearlMatchingProducts(payload)
        .then((response) => {
          if (response?.content?.length) {
            setData([...response.content]);
            setPageCount(response.totalPages);
          } else {
            setData([]);
            setPageCount(0);
          }
        })
        .catch((err) => {
          const errorMessage = err?.response?.data?.message ?? `Failed to fetch data`;
          dispatch(
            addToast({
              type: "danger",
              title: "Failure",
              message: errorMessage,
            })
          );
        })
        .finally(() => setLoading(false));
    }
  };

  const handleSearchChange = useAsyncDebounce((value) => {
    setInput(value);
  }, 500);

  const handleSyncSubmitAndClosePopup = async () => {
    await handleSyncSubmit();
    props.setSyncConfigOpen(false);
  };

  const handleSyncSubmit = async () => {
    try {
      const resp = await saveBrightPearlMatchingProducts(data);

      dispatch(
        addToast({
          type: "success",
          title: "Success",
          message: "Product Mapping Saved successfully ",
        })
      );
      return;
    } catch (err) {
      dispatch(
        addToast({
          type: "danger",
          title: "Failure",
          message: err.response.data.message,
        })
      );
    }
  };

  const handleCancel = () => {
    props.setSyncConfigOpen(false);
    props.refreshData();
  };

  return (
    <div
      className="w-100 h-100 d-flex justify-content-center overflow-auto position-absolute"
      style={{
        padding: "4rem 4rem 1rem",
        zIndex: 99,
        top: 0,
        left: 0,
        background: "rgba(0, 0, 0, 0.4)",
      }}
    >
      <div
        className="card dk-card d-flex border-radius-l"
        style={{ minWidth: "100%", minHeight: "70%" }}
      >
        <div className="card-body d-flex flex-column">
          <h3 className="mt-2 mb-xxl">Map Products</h3>

          <form className="form-inline align-items-end">
            {accounts?.data?.length > 1 && (
              <div className="form-group flex-column align-items-start">
                <span className="font-weight-bold text-muted">BrightPearl Store</span>
                <Select
                  placeholder="BrightPearl Store"
                  styles={customStyles}
                  options={accounts?.data || []}
                  menuPlacement="auto"
                  onChange={(e) => {
                    setBrightPearlStore(e);
                    setData([]);
                    setPageCount(0);
                    setPageIndex(0);
                  }}
                  theme={customSelectTheme}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  isSearchable={false}
                  formatOptionLabel={(data) => data.name}
                  isOptionSelected={(data) => data?.id === brightPearlStore?.id}
                />
              </div>
            )}
            <div className="form-group flex-column align-items-start ml-m">
              <span className="font-weight-bold text-muted">BrightPearl Mapping Field</span>
              <Select
                placeholder="BrightPearl Mapping Field"
                styles={customStyles}
                options={brightPearlStatusOption}
                defaultValue={brightPearlStatusOption[0]}
                menuPlacement="auto"
                onChange={(e) => setBrightPearlMappingField(e.value)}
                theme={customSelectTheme}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isSearchable={false}
              />
            </div>
            <div className="form-group flex-column align-items-start ml-m">
              <span className="font-weight-bold text-muted">Deskera Mapping Field</span>
              <Select
                placeholder="Deskera Mapping Field"
                styles={customStyles}
                options={deskeraStatusOptions}
                defaultValue={deskeraStatusOptions[0]}
                onChange={(e) => setDeskeraMappingField(e.value)}
                theme={customSelectTheme}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isSearchable={false}
              />
            </div>
            <div className="form-group flex-column align-items-start flex-grow-1">
              <DKButton
                disabled={isMapProductsDisabled()}
                className={
                  "text-white ml-m " + (isMapProductsDisabled() ? "bg-secondary" : "bg-primary")
                }
                onClick={() => refreshData({ pageSize, pageIndex, sortBy })}
                title={"MAP PRODUCTS"}
                style={{ height: 38 }}
              />
            </div>
            <div className="form-group flex-column align-items-start ml-m">
              <Select
                placeholder={"Select Status"}
                styles={customStyles}
                options={PRODUCT_SYNC_STATUS_FILTER}
                value={productSyncStatusFilter}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.value}
                onChange={(option) => setProductSyncStatusFilter(option)}
              />
            </div>
            <div className="form-group flex-column align-items-start ml-m">
              <div className="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text bg-light">
                    <span className="svg-icon svg-disabled">
                      <SearchLogo />
                    </span>
                  </div>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  onChange={(e) => handleSearchChange(e.target.value)}
                  style={{ height: 38 }}
                />
              </div>
            </div>
          </form>

          <ServerPaginationTable
            data={data}
            minHeight={"auto"}
            columns={columns}
            migrate={""}
            cart="brightpearl"
            refresh={refreshData}
            tab="MatchingSummaryTable"
            pageCount={pageCount}
            loading={loading}
            rowId="id"
          />
          <div className="d-flex flex-row-reverse" style={{ marginTop: "30px" }}>
            <DKButton
              className="bg-success px-4 text-white"
              onClick={handleSyncSubmitAndClosePopup}
              title={"SAVE AND CLOSE"}
              style={{ marginLeft: "10px", marginRight: "10px" }}
            ></DKButton>
            <DKButton
              className="bg-success px-4 text-white"
              onClick={handleSyncSubmit}
              title={"SAVE"}
              style={{ marginLeft: "10px", marginRight: "10px" }}
            ></DKButton>
            <button
              className="btn dk-btn mr-2 px-3 font-weight-bold text-muted border border-secondary"
              onClick={handleCancel}
            >
              <span className="svg-icon svg-baseline mr-2 svg-disabled">
                <CloseIcon />
              </span>
              <span>Cancel</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MapBrightPearlProducts;

function SelectProduct({
  row,
  loadDeskeraOptions,
  deskeraHandleChange,
  productData,
  deskeraMappingField,
}) {
  const [product] = useState(
    row.original.deskeraId
      ? { pid: row.original.deskeraId, name: row.original.deskeraProductName }
      : null
  );

  const loadProductsOptions = Utility.debounce((inputValue, callback) => {
    loadDeskeraOptions(inputValue).then((response) => {
      callback(response);
    });
  }, 250);

  return (
    <AsyncSelect
      placeholder={"Select Product"}
      className="filter-selector ml-3"
      cacheOptions
      defaultOptions={productData}
      maxMenuHeight={250}
      value={product}
      getOptionLabel={(e) => (
        <div class="d-flex  align-items-center " style={{ minWidth: "230px" }}>
          <div className="ellipsis">
            {e.name}
            {e.documentSequenceCode && (
              <small className="d-block text-muted">{e.documentSequenceCode}</small>
            )}
          </div>
          {deskeraMappingField?.isCustomField &&
            e.customField.find(({ code }) => code === deskeraMappingField.value)?.value && (
              <div className="ml-xs fs-s align-items-end">
                (
                {deskeraMappingField?.isCustomField &&
                  deskeraMappingField.value &&
                  e.customField &&
                  e.customField.find(({ code }) => code === deskeraMappingField.value)?.value}
                )
              </div>
            )}
          {deskeraMappingField.value === "BARCODE" && (
            <div className="fs-s align-items-right">
              {deskeraMappingField.value === "BARCODE" && e.barcode}
            </div>
          )}
        </div>
      )}
      getOptionValue={(e) => e.pid}
      loadOptions={loadProductsOptions}
      onChange={(option) => {
        deskeraHandleChange(option, row.index);
      }}
    />
  );
}
